<template>
  <div class="box">
    <div class="box-header">
      <div class="col-6 col-md-6 col-sm-8 col-xs-8">
        <div class="box-tools">
          <div class="input-group input-group-sm div-pesquisa">
            <input v-model="filterText" @keyup.enter="doFilter" type="text" class="form-control pull-right" placeholder="Pesquisar...">
            <div class="input-group-btn">
              <button type="button" class="btn btn-info" @click="doFilter"><i class="fa fa-search"></i></button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-6 col-md-6 col-sm-4 col-xs-4 div-btn-novo">
        <button id="newButton" class="btn btn-sm btn-default btn-novo" @click="atualizar()" style="width: 33px" data-tooltip="Atualizar"><i class="fa fa-refresh" aria-hidden="true"></i></button>
        &nbsp;
        <button class="btn btn-sm btn-warning btn-novo" @click="alterarStatus()" style="width: 33px" data-tooltip="Alterar Status"><i class="glyphicon glyphicon-pencil" aria-hidden="true"></i></button>
        &nbsp;
        <export-excel
          :fields = "listaExcelFields"
          :fetch = "gerarExcel"
          type = "xls"
          worksheet = "Ponto de Apoio"
          name = "zanzar-agendamento.xls"
          class="btn btn-sm btn-primary btn-novo" style="width: 33px"
          data-tooltip="Exportar Excel"
        ><i class="fa fa-file-excel"></i></export-excel>
      </div>
    </div>

    <vuetable ref="vuetable"
      :api-url="urlApi"
      :http-options="httpOptions"
      :fields="fields"
      :sort-order="sortOrder"
      :css="css.table"
      track-by="cd_agendamento"
      pagination-path=""
      :per-page="25"
      :append-params="moreParams"
      @vuetable:pagination-data="onPaginationData"
      @vuetable:loading="onLoading"        
      @vuetable:loaded="onLoaded"
      no-data-template="Nenhum registro encontrado"
    >
      <template slot="status_desc" slot-scope="props">
        <span class="label" v-bind:class="{
            'label-warning': props.rowData.idc_status === 1,
            'label-info': props.rowData.idc_status === 2,
            'label-default': props.rowData.idc_status === 3,
            'label-success': props.rowData.idc_status === 4,
            'label-danger': [5,9].includes(props.rowData.idc_status)
          }">{{ props.rowData.status_desc }}</span>
      </template>
      <template slot="actions" slot-scope="props">
        <div class="table-button-container" style="text-align: center">
          <div class="btn-group">
            <a @click="view(props.rowData)" class="btn btn-sm btn-success legitRipple" data-tooltip="Abrir" data-delay="500" data-hasqtip="0" aria-describedby="qtip-0"><span class="glyphicon glyphicon-eye-open"></span></a>
            <a @click="editar(props.rowData)" class="btn btn-sm btn-warning legitRipple" data-tooltip="Editar" data-delay="500" data-hasqtip="0" aria-describedby="qtip-0"><span class="glyphicon glyphicon-pencil"></span></a>
          </div>
        </div>
      </template>
      <template slot="dataHora" slot-scope="props">
        {{ formatarData(props.rowData.dt_agendada, (props.rowData.ponto_apoio ? props.rowData.ponto_apoio.idc_agenda_hora : false)) }}
      </template>
    </vuetable>
    <div class="row vuetable-pagination ui basic segment grid" style="padding: 10px">
      <vuetable-pagination-info ref="paginationInfo"
        :css="css.pagination"
        info-template="Exibindo {from} - {to} de {total}"
        no-data-template="" />

      <vuetable-pagination ref="pagination"
        :css="css.pagination"
        @vuetable-pagination:change-page="onChangePage"
        style="margin: 0" />
    </div>

    <modal name="modal-agendamento" :adaptive="false" width="600" height="auto">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$modal.hide('modal-agendamento')"><span aria-hidden="true">×</span></button>
          <h3 class="modal-title">{{ titleModal }}</h3>
        </div>
        <div class="modal-body">
					  <div v-show="errorMessageModal != ''" class="alert alert-danger">{{ errorMessageModal }}</div>

            {{ bodyModal }}
            <br /><br />

            <label for="idc_status">Novo Status</label>
              <select id="idc_status" v-model="idc_status" style="width: auto" class="form-control form-filtro" v-bind:class="{ 'box-input-required': errors.idc_status }">
                <option value="2">Agendado</option>
                <option value="3">Em Andamento</option>
                <option value="4">Finalizado</option>
                <option value="5">Não Executado</option>
                <option value="9">Cancelado</option>
              </select>
              <span v-show="errors.idc_status != null" class="help-inline">{{ errors.idc_status }}</span>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-default pull-left" @click="$modal.hide('modal-agendamento')">Cancelar</button>
          <button type="button" class="btn btn-primary" @click="modalAgendamentoConfirma()">Confirmar</button>
        </div>
      </div>
    </modal>

    <modal name="modal-erro" :adaptive="false" width="600" height="auto" class="modal-danger">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$modal.hide('modal-erro')"><span aria-hidden="true">×</span></button>
          <h3 class="modal-title">{{ titleModal }}</h3>
        </div>
        <div class="modal-body">
          <div v-html="bodyModal"></div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-default" @click="$modal.hide('modal-erro')">Fechar</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { Vuetable, VuetablePagination, VuetablePaginationInfo } from 'vuetable-2'
import VuetableCss from './../../helpers/VuetableCss'
import Formatters from '../../helpers/Formatters'
import AgendamentoActions from '../../actions/AgendamentoActions'
import ActionsLogin from '../../actions/LoginActions'
import moment from 'moment'

export const motivoColumn = {
  name: 'motivo_nao_execucao.descricao',
  title: 'Motivo Não Execução',
  sortField: 'motivo_nao_execucao.descricao',
  visible: (this.status === 5)
}

export default {
  name: 'Listar',
  props: ['titulo', 'status'],
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo
  },
  data () {
    return {
      titleModal: '',
      bodyModal: '',
      errorMessageModal: '',
      errors: {},
      idc_status: '',
      css: VuetableCss,
      listaExcelFields: {
        'Codigo': 'cd_agendamento',
        'Cod Motorista': 'cd_motorista',
        'Cod Ponto Apoio': 'cd_ponto_apoio',
        'Data': 'dt_agendada',
        'Observação': 'observacao',
        'Cod Status': 'idc_status',
        'Serviço': 'tipo_servico.descricao',
        'Status': 'status_desc',
        'Motivo Não Execução': 'motivo_nao_execucao.descricao',
        'Criado em': 'createdAt',
        'Alterado em': 'updatedAt',
        'Motorista': 'motorista.nome',
        'CPF': 'motorista.cpf'
      },
      filterText: '',
      urlApi: process.env.URL_API_BASE + '/agendamento' + ((this.status !== null && this.status !== undefined) ? ('/listar-por-status/' + this.status) : ''),
      motivoColumn: motivoColumn,
      fields: [
        {
          name: '__checkbox',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
        },
        {
          name: 'cd_agendamento',
          title: 'Código',
          sortField: 'cd_agendamento'
        },
        {
          name: 'cd_ponto_apoio',
          title: 'Ponto Apoio',
          sortField: 'cd_ponto_apoio'
        },
        {
          name: 'motorista.nome',
          title: 'Motorista',
          sortField: 'motorista.nome'
        },
        {
          name: 'motorista.tel_celular',
          title: 'Telefone',
          sortField: 'motorista.tel_celular',
          callback: 'formataNumeroTelefone'
        },
        {
          name: '__slot:dataHora',
          title: 'Data Agendada',
          sortField: 'dt_agendada'
        },
        {
          name: 'tipo_servico.descricao',
          title: 'Serviço',
          sortField: 'tipo_servico.descricao'
        },
        {
          name: '__slot:status_desc',
          title: 'Status',
          sortField: 'status_desc'
        },
        motivoColumn,
        '__slot:actions'
      ],
      sortOrder: [
        { field: 'dt_agendada', direction: 'desc' },
        { field: 'createdAt', direction: 'desc' }
      ],
      moreParams: {}
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = this.titulo

    this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))

    if (this.status === 5) {
      this.motivoColumn.visible = true
      this.$refs.vuetable.normalizeFields()
    }
  },
  computed: {
    httpOptions () {
      return { headers: { 'Authorization': 'Bearer ' + ActionsLogin.getToken() } }
    }
  },
  watch: {
    status: function (val) {
      if (this.status !== null && this.status !== undefined) {
        this.$parent.$parent.$data.description = this.titulo
        this.urlApi = process.env.URL_API_BASE + '/agendamento/listar-por-status/' + this.status

        this.motivoColumn.visible = this.status === 5
        this.$refs.vuetable.normalizeFields()
      } else {
        this.$parent.$parent.$data.description = 'Listar'
        this.urlApi = process.env.URL_API_BASE + '/agendamento'
      }
    }
  },
  methods: {
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    onLoading () {
      this.$parent.$parent.$data.showModalLoader = true
    },
    onLoaded () {
      this.$refs.vuetable.selectedTo = []
      this.$parent.$parent.$data.showModalLoader = false
    },
    onFilterSet (filterText) {
      this.moreParams.filter = filterText

      Vue.nextTick(() => {
        if (this.$refs.vuetable !== undefined) {
          this.$refs.vuetable.refresh()
        }
      })
    },
    doFilter () {
      this.$events.fire('filter-set', this.filterText)
    },
    atualizar () {
      this.doFilter()
    },
    editar (rowData) {
      this.$router.push({ path: '/agendamentos/' + rowData.cd_agendamento + '/e', query: { ret_url: this.$router.currentRoute.path } })
    },
    view (rowData) {
      this.$router.push({ path: '/agendamentos/' + rowData.cd_agendamento, query: { ret_url: this.$router.currentRoute.path } })
    },
    excluir (rowData) {
    },
    async gerarExcel () {
      this.$refs.vuetable.refresh()
      let res = await AgendamentoActions.listarAgendamento(this.status)
      return res
    },
    formataNumeroTelefone (val) {
      return val != null ? Formatters.formataNumeroTelefone(val) : ''
    },
    formatarData (val, exibeHora = false) {
      let date = moment(val)
      if (date.isValid()) {
        return exibeHora ? date.format('DD/MM/YYYY HH:mm') : date.format('DD/MM/YYYY')
      }
      return ''
    },
    alterarStatus () {
      if (this.$refs.vuetable.selectedTo.length > 0) {
        this.titleModal = 'Alterar Status'
        this.idc_status = ''
        this.errorMessageModal = ''
        this.errors = {}

        if (this.$refs.vuetable.selectedTo.length > 1) {
          this.bodyModal = 'Todos os ' + this.$refs.vuetable.selectedTo.length + ' agendamentos selecionados serão alterados para o novo status escolhido.'
        } else {
          this.bodyModal = 'O agendamento selecionado será alterado para o novo status escolhido.'
        }

        this.$modal.show('modal-agendamento')
      } else {
        this.titleModal = 'Erro'
        this.bodyModal = 'Selecione ao menos um registro para alterar.'

        this.$modal.show('modal-erro')
      }
    },
    modalAgendamentoConfirma () {
      this.errorMessageModal = ''
      this.errors = {}

      if (this.idc_status) {
        if (this.$refs.vuetable.selectedTo.length > 0) {
          this.$parent.$parent.$data.showModalLoader = true

          AgendamentoActions.alterarStatusEmLote(this.$refs.vuetable.selectedTo, this.idc_status)
            .then(res => {
              this.$modal.hide('modal-agendamento')
              this.$parent.$parent.$data.showModalLoader = false

              this.$refs.vuetable.selectedTo = []
              this.doFilter()
            })
            .catch((error) => {
              console.log(error.message)
              this.errorMessageModal = 'Ocorreu um erro ao alterar.'

              this.$parent.$parent.$data.showModalLoader = false
            })
        }
      } else {
        this.errors.idc_status = 'Este campo deve ser preenchido.'
        this.idc_status = null
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/agendamentos/Listar.vue